import { Box, SxProps, Typography, useTheme } from "@mui/material";

type Props = {
  name: string;
  backgroundColor?: string;
  color?: string;
  width?: string;
  fontSize?: string;
  sx?: SxProps;
};

const InitialsAvatar = ({
  name,
  backgroundColor,
  color = "#fff",
  width = "34px",
  fontSize = "15px",
  sx,
}: Props) => {
  const theme = useTheme();

  const initials = name
    .split(" ")
    .map((string) => string[0])
    .join("");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "100%",
        width: width,
        height: width,
        backgroundColor: backgroundColor || theme.palette.primary.main,
        color,
        ...sx,
      }}
    >
      <Typography variant="header" sx={{ fontWeight: 700, fontSize }}>
        {initials}
      </Typography>
    </Box>
  );
};

export default InitialsAvatar;
